import type { Achievement } from "../achievement.types";
import { allMoves } from "../moveHistory";

export const hereBeDragonsAchievement: Achievement = {
  id: "hereBeDragons",
  name: "Here Be Dragons",
  icon: "map-marker-question-outline",
  description:
    "Left the gold path after a Global Optimal move and found your way back to it.",
  isProgressive: true,
  // After a gold step, a move from an off-route word onto a gold word other
  // than the target. Stepping along the gold path, backward or not, never
  // leaves it; backtracked moves count, but a backtrack is not a return.
  check: (gameReport, gameStatus) => {
    if (
      !["won", "given_up"].includes(gameStatus) ||
      !gameReport ||
      !gameReport.optimalPath ||
      gameReport.optimalPath.length < 2
    ) {
      return false;
    }
    const gold = new Set(gameReport.optimalPath);
    const target = gameReport.optimalPath[gameReport.optimalPath.length - 1];
    let madeOptimalStep = false;
    for (const m of allMoves(gameReport)) {
      if (
        madeOptimalStep &&
        !gold.has(m.playerPosition) &&
        gold.has(m.playerChose) &&
        m.playerChose !== target
      ) {
        return true;
      }
      if (m.isGlobalOptimal) madeOptimalStep = true;
    }
    return false;
  },
};
